import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_statement_ceramics: FaireThemeEntity = {
  token: "discovery_theme_statement-ceramics",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Statement Ceramics",
  description: "Handcrafted ceramics that stand out on any shelf",
  bgColor: "#D4EBD4",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
